<div class="financeiro-page">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div>
      <h1>Configuração API Banrisul</h1>
      <p class="text-muted small mb-0">
        Credenciais do
        <a href="https://developers.banrisul.com.br/" target="_blank" rel="noopener noreferrer">Portal do Desenvolvedor Banrisul</a>
        para registro de boletos via API Cobrança v1.
        Configuração vinculada à <strong>empresa ID 2</strong> (tabela <code>FIN_COBRANCA_BANCO</code>, banco 041).
      </p>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="carregando" (click)="carregarConfig()">
        <i class="fa fa-refresh"></i> Recarregar
      </button>
      <a routerLink="/gerar-boleto" class="btn btn-outline-secondary btn-sm">Gerar boleto</a>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Dados da conta (cobrança)</h2>
    <div class="row g-2 form-grid">
      <div class="col-md-6">
        <label class="form-label">Nome do banco</label>
        <input type="text" class="form-control form-control-sm" maxlength="100" [(ngModel)]="configForm.descricao" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Beneficiário (7 dígitos) *</label>
        <input type="text" class="form-control form-control-sm" maxlength="7" [(ngModel)]="configForm.codigoBeneficiario"
          placeholder="Código convênio" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Código completo (13 dígitos)</label>
        <input type="text" class="form-control form-control-sm" maxlength="13" [(ngModel)]="configForm.codigoBeneficiarioCompleto"
          placeholder="Agência + beneficiário + controle" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Agência *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="configForm.agencia" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Dígito agência</label>
        <input type="text" class="form-control form-control-sm" maxlength="2" [(ngModel)]="configForm.digitoAgencia" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Conta *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="configForm.contaCorrente" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Dígito conta *</label>
        <input type="text" class="form-control form-control-sm" maxlength="2" [(ngModel)]="configForm.digitoConta"
          title="Usado também como controle (2 dígitos) do bergs-beneficiario" />
      </div>
      <div class="col-md-8">
        <label class="form-label">Nome beneficiário (cobrança)</label>
        <input type="text" class="form-control form-control-sm" maxlength="60" [(ngModel)]="configForm.nomeBeneficiarioCobranca" />
      </div>
    </div>
    <p class="text-muted small mb-0 mt-2" *ngIf="codigoBeneficiarioCompleto">
      Código <code>bergs-beneficiario</code> calculado: <strong>{{ codigoBeneficiarioCompleto }}</strong>
    </p>
    <div class="alert alert-light border small py-2 mt-2 mb-0" *ngIf="ehHomologacao()">
      <strong>Homologação (Sandbox):</strong>
      conecta em <code>{{ urlsHomologacao.token }}</code>.
      Use o beneficiário de sucesso <code>0010000001088</code> (preenchido automaticamente).
      No Sandbox não é necessário convênio real — os códigos são fictícios conforme a
      <a href="https://developers.banrisul.com.br/pages/docs/clientes-banrisul/api-cobranca-v1.html#section/Testes/Ambiente-Sandbox" target="_blank" rel="noopener noreferrer">documentação</a>.
      <ul class="mb-0 mt-1 ps-3">
        <li *ngFor="let b of beneficiariosSandbox">
          <code>{{ b.codigo }}</code> — {{ b.descricao }}
        </li>
      </ul>
    </div>
    <div class="alert alert-info border small py-2 mt-2 mb-0" *ngIf="ehCertificacao()">
      <strong>Certificação (orientação Banrisul):</strong>
      host de produção <code>{{ urlsCertificacao.api }}</code> com payload
      <code>ambiente: T</code> e <strong>beneficiário real</strong>.
      Registre boletos em <a routerLink="/gerar-boleto">Gerar boleto</a> até obter retorno
      <code>04</code> — aí o convênio é liberado em produção e não é preciso enviar arquivos de teste.
    </div>
    <div class="alert alert-light border small py-2 mt-2 mb-0" *ngIf="ehProducao()">
      <strong>Produção:</strong>
      URL <code>{{ urlsProducao.api }}</code> — registro efetivo de boletos (<code>ambiente: P</code>).
      Use o convênio real da sua conta. Após certificação (retorno 04), envie 5 testes para
      <a [href]="'mailto:' + emailHomologacao">{{ emailHomologacao }}</a> apenas se o Banrisul ainda solicitar.
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Encargos padrão (multa e juros)</h2>
    <p class="text-muted small mb-3">
      Enviados em <code>titulo.instrucoes</code> no registro do boleto.
      Juros: código 2 (taxa mensal %). Multa: código 2 (percentual, 1 casa decimal).
      Se o título tiver multa/juros próprios no financeiro, esses valores têm prioridade.
    </p>
    <div class="row g-2 form-grid">
      <div class="col-md-3">
        <label class="form-label">Multa (%)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="0"
          max="60"
          step="0.1"
          [(ngModel)]="configForm.apiMultaPercentual"
          placeholder="Ex.: 2.0"
        />
        <small class="text-muted">% sobre o valor do título</small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Juros mensal (%)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="0"
          max="60"
          step="0.01"
          [(ngModel)]="configForm.apiJurosPercentualMensal"
          placeholder="Ex.: 10.00"
        />
        <small class="text-muted">Código 2 — taxa mensal</small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Dias após venc. (multa)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="1"
          max="99"
          step="1"
          [(ngModel)]="configForm.apiMultaDiasAposVencimento"
          placeholder="1"
        />
        <small class="text-muted">Data da multa &gt; vencimento</small>
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Credenciais da aplicação (OAuth2)</h2>
    <div class="row g-2 form-grid">
      <div class="col-md-3">
        <label class="form-label">Ambiente</label>
        <select class="form-control form-control-sm" [(ngModel)]="configForm.apiAmbiente" (ngModelChange)="onAmbienteChange()">
          <option value="H">Homologação (Sandbox)</option>
          <option value="C">Certificação (produção + ambiente T)</option>
          <option value="P">Produção</option>
        </select>
        <small class="text-muted d-block mt-1" *ngIf="ehHomologacao()">
          Token: <code>{{ urlsHomologacao.token }}</code>
        </small>
        <small class="text-muted d-block mt-1" *ngIf="ehCertificacao()">
          Token: <code>{{ urlsCertificacao.token }}</code> — payload registro <code>ambiente: T</code>
        </small>
        <small class="text-muted d-block mt-1" *ngIf="ehProducao()">
          Token: <code>{{ urlsProducao.token }}</code> — payload registro <code>ambiente: P</code>
        </small>
        <div class="alert alert-warning border small py-2 mt-2 mb-0" *ngIf="usaHostProducao()">
          <strong>Certificação e Produção usam credenciais do portal de Produção.</strong>
          O Client ID e o Client Secret do Sandbox <em>não</em> funcionam em
          <code>api.banrisul.com.br</code>.
          Cole o Secret, clique em <strong>Salvar</strong> e só então em <strong>Testar conexão</strong>.
        </div>
      </div>
      <div class="col-md-5">
        <label class="form-label">Client ID (API Key) *</label>
        <input
          #clientIdInput
          type="text"
          class="form-control form-control-sm"
          name="banrisulApiClientId"
          [(ngModel)]="apiClientId"
          (input)="apiClientId = clientIdInput.value"
          autocomplete="off"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">Client Secret (Shared Secret) *</label>
        <input
          #clientSecretInput
          type="password"
          class="form-control form-control-sm"
          name="banrisulApiClientSecret"
          [(ngModel)]="apiClientSecret"
          (input)="apiClientSecret = clientSecretInput.value"
          [placeholder]="clientSecretConfigurado ? 'Deixe em branco para manter o atual' : ''"
          autocomplete="new-password"
        />
      </div>
    </div>
    <p class="text-muted small mb-0 mt-2" *ngIf="ehHomologacao()">
      OAuth: Basic Auth (Client ID / Secret) + body <code>grant_type=client_credentials</code> e <code>scope=boletos</code>
      (conforme collection Postman do Banrisul).
    </p>
    <p class="text-muted small mb-0 mt-2" *ngIf="ehCertificacao()">
      Após conectar, use <strong>Gerar boleto → Registrar no Banrisul</strong>.
      O sistema envia <code>ambiente: T</code> e só aceita sucesso com retorno <code>04</code>
      (liberação automática do beneficiário, conforme e-mail do Banrisul).
    </p>
    <div class="alert alert-warning border small py-2 mt-2 mb-0" *ngIf="ehHomologacao()">
      <strong>Se o teste de conexão retornar <code>invalid_client</code>:</strong>
      isso vem do servidor OAuth do Banrisul — não é erro de URL nem de beneficiário de teste.
      Pela documentação, o fluxo obrigatório é:
      <ol class="mb-0 mt-1 ps-3">
        <li>Solicitar acesso ao Sandbox por e-mail:
          <a [href]="'mailto:' + emailHomologacao">{{ emailHomologacao }}</a>
        </li>
        <li>Aguardar ativação da conta no Portal de Desenvolvedores</li>
        <li>Criar aplicação com a <strong>API Cobrança v1</strong> vinculada (não outra API do portal)</li>
        <li>Gerar <strong>novo</strong> Client ID / Secret (os enviados pelo suporte) e salvar nesta tela</li>
        <li>Validar no Postman: Basic Auth + <code>scope=boletos</code> em <code>{{ urlsHomologacao.token }}</code></li>
      </ol>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Webhook de pagamentos</h2>
    <p class="text-muted small">
      O Banrisul notifica alterações no título (ex.: pagamento). A aplicação confirma com
      <code>{{ consultaBoletoApiPath }}</code> antes de baixar a conta a receber.
      Em produção, cadastre a URL com o e-mail
      <a [href]="'mailto:' + emailHomologacao">{{ emailHomologacao }}</a>.
    </p>
    <div class="row g-2 form-grid">
      <div class="col-md-8">
        <label class="form-label">URL do webhook (HTTPS)</label>
        <input type="url" class="form-control form-control-sm" [(ngModel)]="configForm.webhookUrl"
          placeholder="https://sua-api/api/financeiro/BanrisulWebhook/2" />
        <small class="text-muted" *ngIf="webhookUrlSugerida">
          Sugestão (esta API):
          <a href="#" (click)="$event.preventDefault(); usarUrlWebhookSugerida()">{{ webhookUrlSugerida }}</a>
        </small>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="webhookBoletoBanrisul" [(ngModel)]="configForm.webhookBoletoAtivo" />
          <label class="form-check-label" for="webhookBoletoBanrisul">Webhook de boleto ativo</label>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap gap-2 mt-2">
      <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="ehHomologacao()"
        [disabled]="testandoWebhook" (click)="testarWebhook()">
        <i class="fa fa-bell"></i> Testar webhook (sandbox)
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="ehHomologacao()"
        [disabled]="testandoConsultaLiquidado" (click)="testarConsultaLiquidado()">
        <i class="fa fa-check-circle"></i> Testar consulta liquidado (7781)
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="carregarWebhookLogs()">
        <i class="fa fa-list"></i> Atualizar logs
      </button>
    </div>
    <div class="table-responsive mt-3" *ngIf="webhookLogs.length">
      <table class="table table-sm table-striped mb-0">
        <thead>
          <tr>
            <th>Data</th>
            <th>Conta</th>
            <th>Nosso nº</th>
            <th>Liquidação</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of webhookLogs">
            <td>{{ log.dataHora || '-' }}</td>
            <td>{{ log.idContaReceber || '-' }}</td>
            <td>{{ log.nossoNumero || '-' }}</td>
            <td>{{ log.liquidacaoAplicada ? 'Sim' : 'Não' }}</td>
            <td class="small">{{ log.mensagem || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex flex-wrap gap-2">
    <button type="button" class="btn btn-primary btn-sm" [disabled]="salvandoConfig" (click)="salvarConfiguracao()">
      <i class="fa fa-save"></i> Salvar configuração
    </button>
    <button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="ehHomologacao()" (click)="aplicarDadosHomologacao(true)">
      <i class="fa fa-flask"></i> Aplicar dados Sandbox
    </button>
    <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="testandoConexao" (click)="testarConexao()">
      <i class="fa fa-plug"></i> Testar conexão
    </button>
  </div>
</div>
